module.exports = __webpack_public_path__ + "static/img/lcb_rz.9d12a46.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/lcb_rz.png
// module id = nj3s
// module chunks = 0